// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__s4fH0","footer__info-for-professionals":"styles_footer__info-for-professionals__xJk4W","footer__data-privacy":"styles_footer__data-privacy__y0aZQ"};